import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  ModalFooter,
  Modal,
} from '@chakra-ui/react';
import { useMenuDeleteStore } from '../../hooks';

type Props = ReturnType<typeof useMenuDeleteStore>;

export const MenuDeleteModalView: FC<Props> = ({
  values,
  isOpenModal,
  onCloseModal,
  onDeleteMenu,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="2xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px">メニューの削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>メニューID</FormLabel>
            <Input
              type="text"
              value={values.id}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>メニュー名</FormLabel>
            <Input
              type="text"
              value={values.name}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記のメニュー情報を削除しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button colorScheme="red" onClick={onDeleteMenu} w="140px">
          削除
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
